document.addEventListener('DOMContentLoaded', function(){
  var revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry, i){
      if(entry.isIntersecting){
        setTimeout(function(){ entry.target.classList.add('is-visible'); }, i * 35);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -10px 0px' });
  function observeReveal(root){
    root.querySelectorAll('.reveal, .mission p').forEach(function(el){ revealObserver.observe(el); });
  }
  observeReveal(document);

  var burger = document.getElementById('menuToggle');
  if(burger){
    burger.addEventListener('click', function(){
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    });
  }

  document.querySelectorAll('.nav-item.has-dropdown > .nav-item__toggle').forEach(function(toggle){
    toggle.addEventListener('click', function(e){
      e.preventDefault();
      var item = toggle.closest('.nav-item');
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.nav-item.is-open').forEach(function(openItem){
        if(openItem !== item) openItem.classList.remove('is-open');
      });
      item.classList.toggle('is-open', !wasOpen);
    });
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('.nav-item.has-dropdown')){
      document.querySelectorAll('.nav-item.is-open').forEach(function(openItem){ openItem.classList.remove('is-open'); });
    }
  });

  document.querySelectorAll('.product-recommendations[data-url]').forEach(function(el){
    fetch(el.getAttribute('data-url'))
      .then(function(res){ return res.text(); })
      .then(function(html){
        if(html && html.trim() !== ''){
          el.innerHTML = html;
          el.querySelectorAll('.reveal').forEach(function(r){ r.classList.add('is-visible'); });
        }
      })
      .catch(function(){});
  });

  document.querySelectorAll('.variant-picker').forEach(function(picker){
    var dataElId = picker.getAttribute('data-variants-json');
    var dataEl = dataElId ? document.getElementById(dataElId) : null;
    if(!dataEl) return;
    var parsed;
    try { parsed = JSON.parse(dataEl.textContent); } catch(e){ return; }
    var variants = parsed.variants || [];
    var form = picker.closest('form');
    if(!form) return;
    var idInput = form.querySelector('.variant-id-input');
    var submitBtn = form.querySelector('.product-form-submit');
    var btnLabel = submitBtn ? submitBtn.querySelector('.btn-label') : null;
    var priceEl = form.parentElement ? form.parentElement.querySelector('.product-price') : null;

    var optionGroups = picker.querySelectorAll('.variant-option');
    var optionNames = [];
    var selections = {};
    optionGroups.forEach(function(group){
      var pills = group.querySelectorAll('.variant-pill');
      if(!pills.length) return;
      optionNames.push(pills[0].getAttribute('data-option-name'));
      var selected = group.querySelector('.variant-pill.is-selected') || pills[0];
      selections[selected.getAttribute('data-option-name')] = selected.getAttribute('data-value');
    });

    function updateVariant(){
      var match = variants.find(function(v){
        return optionNames.every(function(name, idx){
          return v.options[idx] === selections[name];
        });
      });
      if(match){
        if(idInput) idInput.value = match.id;
        if(priceEl && match.price) priceEl.textContent = match.price;
        if(submitBtn) submitBtn.disabled = !match.available;
        if(btnLabel) btnLabel.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';
      }
    }

    picker.querySelectorAll('.variant-pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        var group = pill.closest('.variant-pills');
        group.querySelectorAll('.variant-pill').forEach(function(p){ p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selections[pill.getAttribute('data-option-name')] = pill.getAttribute('data-value');
        updateVariant();
      });
    });
  });

  document.querySelectorAll('.product-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var targetId = thumb.getAttribute('data-main-target');
      var mainImg = targetId ? document.getElementById(targetId) : null;
      var full = thumb.getAttribute('data-full');
      if(mainImg && full){
        mainImg.src = full;
      }
      var group = thumb.parentElement;
      if(group){
        group.querySelectorAll('.product-thumb').forEach(function(t){ t.classList.remove('is-active'); });
      }
      thumb.classList.add('is-active');
    });
  });
});
